import { combineReducers } from 'redux';

import ipGeolocationModal from './modal-upload/redux/reducer';
import ipGeolocationGrid from './grid/redux/reducer';

export default combineReducers({
  modal: ipGeolocationModal,
  grid: ipGeolocationGrid
});
